import { findNavbarItemBySubState } from 'constants/notificationSubState'

export const FINALIZED_NAV_ID = 5

const isFinalizedTab = (item: any) => item && item.id === FINALIZED_NAV_ID

const withoutSubState = (item: any) => item && !item?.u_sub_state

const pickFinalizedItem = (navbar: any[], subState?: string) => {
    const finalizedItems = navbar.filter(isFinalizedTab)

    if (subState && subState !== '') {
        return (
            findNavbarItemBySubState(navbar, FINALIZED_NAV_ID, subState) ||
            finalizedItems.find(withoutSubState) ||
            finalizedItems[0] ||
            null
        )
    }

    return finalizedItems.find(withoutSubState) || finalizedItems[0] || null
}

const pickTabItemFromBackend = (navbar: any[], item: any) => {
    if (!item || isFinalizedTab(item)) {
        return item
    }

    return navbar.find((candidate) => candidate && candidate.id === item.id && withoutSubState(candidate)) || item
}

// Monta as abas com os number da resposta atual. Zero do backend é valor válido, não cache.
export const buildNavbarItems = (navbar: any[] | undefined, subState?: string): any[] => {
    if (!navbar?.length) {
        return []
    }

    const finalizedToShow = pickFinalizedItem(navbar, subState)
    const originalFinalizedIndex = navbar.findIndex(isFinalizedTab)

    let items = navbar.filter((item) => !isFinalizedTab(item))

    if (finalizedToShow) {
        const insertAt = originalFinalizedIndex === -1 ? items.length : Math.min(originalFinalizedIndex, items.length)
        items.splice(insertAt, 0, finalizedToShow)
    }

    const resolvedItems = items
        .map((item) => pickTabItemFromBackend(navbar, item))
        .filter((item) => !item || isFinalizedTab(item) || withoutSubState(item))

    return resolvedItems.filter((item, index, list) => {
        if (!item) return true
        return list.findIndex((candidate) => candidate && candidate.id === item.id) === index
    })
}
